import { render, staticRenderFns } from "./billboardMsg.vue?vue&type=template&id=22389da0&"
import script from "./billboardMsg.vue?vue&type=script&lang=js&"
export * from "./billboardMsg.vue?vue&type=script&lang=js&"
import style0 from "./billboardMsg.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports